angular.module('mx.components').factory('mx.components.MxGridHelper', MxGridHelper);

MxGridHelper.$inject = [];

export function MxGridHelper() {
	const gridHelper = {
		preventStuckingMovingColumns,
	};

	return gridHelper;

	// Prevent Stucking Columns while moving them beyond horizontal scroll. Can be removed after this bug is fixed: https://github.com/angular-ui/ui-grid/issues/6603
	function preventStuckingMovingColumns($scope, $element) {
		$scope.$applyAsync(function () {
			$element.find('.ui-grid-header-cell-row')[0].addEventListener(
				'mousedown',
				() => {
					$(document).one('mouseup', () => {
						setTimeout(() => {
							const clonedStuckedColumn = $element.find('.movingColumn');
							if (clonedStuckedColumn.length) {
								clonedStuckedColumn.remove();
							}
						}, 100);
					});
				},
				true
			);
		});
	}
}
